import React from 'react';
import { Col, Form } from 'react-bootstrap';

const FormInput = ({ classes, title, type, required, handleChange }) => {
      return (
            <>
                  <Form.Group as={Col} lg={classes ? classes : 6}>
                        <Form.Label>
                              {title}{' '}
                              {required && (
                                    <span className="text-danger">*</span>
                              )}
                        </Form.Label>
                        <Form.Control
                              type={type ? type : 'text'}
                              required={required}
                              onChange={(event) =>
                                    handleChange(event.target.value)
                              }
                        />
                  </Form.Group>
            </>
      );
};

export default FormInput;
